import {  realBricksApi } from "../../utils/axiosInterceptors";

export const resetLoginPin = async () => {
    const response = await realBricksApi.post(
      `/api/v1/user/reset-pin-code`
    );
    return response.data;
};

export const verifyResetPinCodeApi = async (pin) => {
    const response = await realBricksApi.post(
      `/api/v1/user/verify-reset-pin-code`, pin
    );
    return response.data;
};

export const setNewPinApi = async (pin) => {
    const response = await realBricksApi.put(
      `/api/v1/user/reset-pin`, pin
    );
    return response.data;
};

export const verifyOldPassword = async (password) => {
  const response = await realBricksApi.post(
    `/api/v1/user/validate-password`, password
  );
  return response.data;
};

export const setNewPassword = async (newPassword) => {
  const response = await realBricksApi.put(
    `/api/v1/user/password`, newPassword
  );
  return response.data;
};

export const verifyPin = async (pin) => {
  const response = await realBricksApi.post(
    `/api/v1/user/validate-pin`, pin
  );
  return response.data;
};

export const updateEmailAndPhone = async (data) => {
  const response = await realBricksApi.put(
    `/api/v1/user/email-and-phone`, data
  );
  return response.data;
};
export const verifyEmailAndPhoneCode = async (verificationCode) => {
  const response = await realBricksApi.post(
    `/api/v1/user/verify-email-phone-code`, verificationCode
  );
  return response.data;
};
export const resendEmailAndPhoneCode = async (resendType) => {
  const response = await realBricksApi.post(
    `/api/v1/user/resend-email-and-phone-code`, resendType
  );
  return response.data;
};
export const requestNameChange = async () => {
  const response = await realBricksApi.post(
    `/api/v1/user/name-change-request-email`
  );
  return response.data;
}
export const nameChange = async (data) => {
  const response = await realBricksApi.put(
    `/api/v1/user/user-name`, data
  );
  return response.data;
}